import { useState } from "react";
import { faqList } from "../../../mocks/guaData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20" aria-label="常见问题">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="text-sm font-semibold uppercase tracking-wider text-accent-600">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              关于吃瓜神器，你可能想问的
            </h2>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              把大家最常问的问题集中在这里，帮你快速解答关于吃瓜神器的各种疑问。
              如果这里没有你要的答案，欢迎到底部留言与我们交流。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <span className="rounded-md bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">快速解答</span>
              <span className="rounded-md bg-background-50 px-3 py-1 text-xs font-medium text-foreground-600 ring-1 ring-background-200">
                纯干货
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="flex flex-col gap-3">
              {faqList.map((item, idx) => {
                const isOpen = openIdx === idx;
                return (
                  <div
                    key={item.q}
                    className={`overflow-hidden rounded-lg bg-background-50 ring-1 transition-all ${
                      isOpen ? "ring-primary-300" : "ring-background-200"
                    }`}
                  >
                    <button
                      type="button"
                      className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                      onClick={() => setOpenIdx(isOpen ? null : idx)}
                      aria-expanded={isOpen}
                    >
                      <h3 className="flex-1 text-sm font-semibold text-foreground-950 md:text-base">
                        {item.q}
                      </h3>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen ? "bg-primary-500 text-white" : "bg-background-100 text-foreground-500"
                        }`}
                      >
                        <i
                          className={`text-sm transition-transform ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}
                          aria-hidden="true"
                        ></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5">
                        <p className="border-t border-background-200 pt-3 text-sm leading-relaxed text-foreground-600">
                          {item.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}